import { Box, Button, Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import { useWait } from 'react-wait'
import ButtonProgress from '../../components/Progress/ButtonProgress'
import { LoggingContext } from '../../contexts/LoggingContext'

export default function SignOn(props) {
  const { signon } = useContext(LoggingContext)
  const { isWaiting } = useWait()
  return <Grid container justify="center">
    <Grid item>
      <Box position="relative">
        <Button onClick={signon} disabled={isWaiting('signon')}>
          Sign On
        </Button>
        <ButtonProgress loading={isWaiting('signon')} />
      </Box>
    </Grid>
  </Grid>
}